const config = {
  requestParams: {
    _productId: '2131',
    _version: '1.0.0',
  },
}

export default config
